import React from "react";
import { Loader2 } from "lucide-react";

function productWord(count) {
  return count === 1 ? "product" : "products";
}

/**
 * Results header: green live light + "16 live products • calculated in 1.181s"
 */
export default function SourcingLiveCount({
  count = 0,
  calcSeconds,
  loading = false,
  countSuffix = "",
  extra = null,
}) {
  const timeLabel =
    !loading && calcSeconds != null && calcSeconds !== ""
      ? ` • calculated in ${calcSeconds}s`
      : "";

  return (
    <div className="min-w-0 max-w-full inline-flex flex-col items-start gap-0.5 md:flex-row md:items-center md:flex-nowrap md:gap-1.5">
      <div className="text-xs md:text-sm text-slate-600 inline-flex items-center flex-nowrap whitespace-nowrap gap-1">
        {loading ? <Loader2 className="h-4 w-4 animate-spin text-sky-500 shrink-0" /> : null}
        <span className="inline-flex items-center gap-1.5">
          {count > 0 ? (
            <span className="relative top-[calc(2px-2%)] left-[3px] flex h-2 w-2 shrink-0" aria-hidden="true">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-500" />
            </span>
          ) : null}
          <span>
            {count} live {productWord(count)}
            {countSuffix}
            {timeLabel}
          </span>
        </span>
      </div>
      {extra}
    </div>
  );
}
